import { getRouteApi } from "@tanstack/react-router";
import { useFamilyRecentActivity } from "creso-core/hooks";
import { useMemo } from "react";
import { RecentActivity } from "../overview/recent-activity";

export function FamilyRecentActivitySection() {
  const route = getRouteApi("/(auth)/_headed/clients/families/$id");
  const { family } = route.useLoaderData();
  const days = 7;
  const { data, hasNextPage, fetchNextPage, isFetchingNextPage, isLoading } =
    useFamilyRecentActivity(family.id, days);

  const activities = useMemo(
    () => data?.pages.flatMap((page) => page.results),
    [data]
  );

  if (!isLoading && !activities?.length) return null;

  return (
    <RecentActivity
      activities={activities}
      days={days}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      fetchNextPage={fetchNextPage}
      showClientAvatar
      className="max-h-95"
    />
  );
}
